import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IQuestApiResponse } from '../../../entity/interface/iRewardSystem';
import { IRewardRepository } from '../../repositories/interfaces/iRewardRepository';

export interface IGetQuestsUseCase {
    execute(identityToken: string, apiKey: string): Promise<IQuestApiResponse['data']>;
}

export class GetQuestsUseCase implements IGetQuestsUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get rewardRepository(): IRewardRepository {
        return container.resolve<IRewardRepository>(DI.REPOSITORIES.IRewardRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(identityToken: string, apiKey: string): Promise<IQuestApiResponse['data']> {
        const response = await this.rewardRepository.getQuests(identityToken, apiKey);
        return response.data;
    }
}
